export const getMetaJson = () => {
  const metaJson = {
    "/": {
      title: "全球语言服务平台",
      keywords:
        "全球,语言,翻译,服务,专业,平台,北京外国语大学,北外,英语,外语,外研社,语种,工具,学习,培训,笔译,口译,留学,外企,商务,出国",
      description:
        "全球语言服务平台由北京外国语大学主持建设，立足国家新一轮对外开放战略和“一带一路”建设，以“共建、共生、共享”为原则，科学整合语言服务产业链中企业、院校、科研机构、人才等核心要素的供需诉求，构建基于大数据的、以“权威、开放、公益、互动”为特色的语言服务平台，培养并储备以（多）语言优势为主、行业知识和技能全面发展的高水平国际化“复语复合型”人才，打造“外向型企业－外语复合型人才－院校/服务商”循环赋能的语言服务生态，以大平台建设助力全球语言服务的即时、透明、公平、智能和可持续发展",
    },
    "/about": {
      title: "全球语服平台-about",
      keywords: "about关键字",
      description: "about描述",
    },
    "/production": {
      title: "全球语服平台-产品介绍",
      keywords: "产品关键字",
      description: "产品描述",
    },
    "/404": {
      title: "全球语服平台-404",
      keywords: "404",
      description: "404",
    },
  };
  return metaJson;
};
